import styled from '@emotion/styled';
import { DialogContent, DialogOverlay } from '@reach/dialog';

import BaseCloseButton, { Props as BaseCloseButtonProps } from '../Shared/components/CloseButton';
import '@reach/dialog/styles.css';

const ModalOverlay = styled(DialogOverlay)`
  z-index: 200;
`;

const ModalContent = styled(DialogContent)`
  && {
    height: 100%;
    margin: 0;
    padding: 0;
    position: relative;
    width: 100%;
  }
`;

const CloseButton = styled(BaseCloseButton)<BaseCloseButtonProps>`
  position: absolute;
  right: 10%;
  top: 2.5rem;
  z-index: 201;
`;

export { ModalOverlay, ModalContent, CloseButton };
